import {
  formatCurrency,
  currencyFormatter,
  convertdollarStringtoNumber,
  convertStringtoDollarString,
} from './currencyFormatHelper';

describe('Currency Format Helper', () => {
  test('currency Formatter', () => {
    expect(currencyFormatter(150.652, 2)).toEqual('150.65');
  });

  test('convert dollar String to Number', () => {
    expect(convertdollarStringtoNumber('$20')).toEqual(20);
  });

  test('convertStringtoDollarString', () => {
    expect(convertStringtoDollarString(250)).toEqual('$250');
  });
});
